export enum StatusJustification {
    CNAE = 1,
    Divergent_value = 2,
    Others = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/StatusJustification.ts